module.exports = __webpack_public_path__ + "img/lens-150-plus-05.7c3ec852.png";